<template>
  <div class="common-words">
    <el-row type="flex" style="margin-bottom: 10px;">
      <el-button type="primary" @click="openDialogWorkOrder('add')">新增</el-button>
      <div style="margin: 0 10px;">
        <el-select v-model="workOrderType" clearable placeholder="选择工单类型">
          <el-option v-for="item in listWorkOrderType" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin: 0 10px 0 0;">
        <el-select v-model="applicableType" clearable placeholder="选择适用者">
          <el-option v-for="item in listApplicableType" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin: 0 10px 0 0;">
        <el-select v-model="priority" clearable placeholder="选择优先级">
          <el-option label="是" :value="1"></el-option>
          <el-option label="否" :value="0"></el-option>
        </el-select>
      </div>
      <el-button type="primary" @click="searchTable">搜索</el-button>
    </el-row>
    <el-table border :header-cell-style="{ textAlign: 'center' }" :data="listTable" v-loading="loadingTable">
      <el-table-column prop="type" label="工单类型" align="center" width="300">
        <template slot-scope="scope">
          <div v-for="item in listWorkOrderType" :key="item.value">
            <div v-if="item.value === scope.row.type">{{ item.label }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="applicable" label="适用者" align="center" width="300">
        <template slot-scope="scope">
          <div v-for="item in listApplicableType" :key="item.value">
            <div v-if="item.value === scope.row.applicable">{{ item.label }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级" align="center" width="200">
        <template slot-scope="scope">
          <el-switch
              v-model="scope.row.priority"
              :active-value="1"
              :inactive-value="0"
              @change="handleTableSwitch(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="300">
        <template slot-scope="scope">
          <el-button type="primary" @click="openDialogWorkOrder('edit', scope.row)">编辑</el-button>
          <el-button type="danger" @click="deleteWorkOrder(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="pagination-box" type="flex" justify="center" align="middle">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[20, 50, 100, 200, 400]"
          :page-size="size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      ></el-pagination>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="closeDialogWorkOrder" top="4vh">
      <el-form label-width="100px">
        <el-form-item label="工单类型">
          <el-radio-group v-model="formHandleWorkOrder.type">
            <el-radio v-for="item in listWorkOrderType" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="适用者">
          <el-radio-group v-model="formHandleWorkOrder.applicable">
            <el-radio v-for="item in listApplicableType" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="内容">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="formHandleWorkOrder.content"></el-input>
        </el-form-item>
        <el-form-item label="是否优先显示">
          <el-switch v-model="formHandleWorkOrder.priority" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="confirmWorkOrder" :loading="loadingWorkOrder">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api';

export default {
  name: "CommonWords",
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      workOrderType: '',
      applicableType: '',
      priority: '',
      listWorkOrderType: [
        { label: 'ERP问题', value: 1 },
        { label: '运营问题', value: 2 },
        { label: '物流问题', value: 3 },
        { label: '采购问题', value: 4 },
      ],
      listApplicableType: [
        { label: '发起者', value: 1 },
        { label: '解决者', value: 2 },
      ],
      listTable: [],
      loadingTable: false,
      dialogTitle: '',
      dialogVisible: false,
      formHandleWorkOrder: {
        content: "",
        type: 1,
        applicable: 1,
        priority: 0,
      },
      loadingWorkOrder: false,
    }
  },
  created() {
    this.getTable()
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getTable()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getTable()
    },
    searchTable() {
      this.page = 1
      this.getTable()
    },
    handleTableSwitch(item) {
      const API = Baseurl + 'commonTermsForWorkOrdersController/updateCommonTermsForWorkOrders'
      const paramsData = item
      // paramsData.id = item.id
      // paramsData.priority = item.priority

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.getTable()
          this.$message.success('操作成功')
        } else {
          this.getTable()
          this.$message.error(data)
        }
      })
    },
    getTable() {
      const API = Baseurl + 'commonTermsForWorkOrdersController/selectCommonTermsForWorkOrders'
      const paramsData = {
        page: this.page,
        size: this.size,
        type: this.workOrderType,
        applicable: this.applicableType,
        priority: this.priority,
      }
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data.list
          this.total = data.total
        }
      })
    },
    openDialogWorkOrder(type, row) {
      if (type === 'add') {
        this.dialogTitle = '新增工单'
        this.dialogVisible = true
      } else if (type === 'edit') {
        this.dialogTitle = '编辑工单'
        this.dialogVisible = true

        this.formHandleWorkOrder.id = row.id
        this.formHandleWorkOrder.type = row.type
        this.formHandleWorkOrder.applicable = row.applicable
        this.formHandleWorkOrder.content = row.content
        this.formHandleWorkOrder.priority = row.priority
      }
    },
    closeDialogWorkOrder() {
      this.formHandleWorkOrder = this.$options.data().formHandleWorkOrder
    },
    confirmWorkOrder() {
      if (!this.formHandleWorkOrder.content) {
        this.$message.warning('请确认是否输入内容')
        return
      }
      let API = Baseurl + 'commonTermsForWorkOrdersController/insertCommonTermsForWorkOrders'
      const paramsData = this.formHandleWorkOrder

      if (this.dialogTitle === '编辑工单') {
        API = Baseurl + 'commonTermsForWorkOrdersController/updateCommonTermsForWorkOrders'
      }
      this.loadingWorkOrder = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingWorkOrder = false
        const { code, data } = res.data
        if (code === 200) {
          this.dialogVisible = false
          this.getTable()
          this.$message.success('操作成功')
        } else {
          this.$message.error(data)
        }
      })
    },
    deleteWorkOrder(row) {
      this.$confirm('确定要删除该项吗', '提示').then(() => {
        const API = Baseurl + 'commonTermsForWorkOrdersController/deleteCommonTermsForWorkOrders'
        const paramsData = { id: row.id }

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          if (code === 200) {
            this.getTable()
            this.$message.success('操作成功')
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.common-words {
  width: 98%;
  overflow: hidden;
  padding-bottom: 52px;

  .pagination-box {
    width: calc(97% - 200px);
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 200px;
    padding: 10px;
    z-index: 999;
  }
}
</style>